let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cjBpP")).then(() => parcelRequire('2Y5wI'));